<template>
  <div>
    <!-- Searchbar -->
    <div class="ecommerce-searchbar m-1">
      <b-row>
        <b-col
          cols="12"
          class="d-flex flex-column justify-content-center text-monospace"
        >
          <b-overlay
            :show="isloader"
            rounded="lg"
            opacity="0.6"
          >
            <template v-slot:overlay>
              <div class="d-flex align-items-center">
                <b-spinner
                  small
                  type="grow"
                  variant="secondary"
                />
                <b-spinner
                  type="grow"
                  variant="dark"
                />
                <b-spinner
                  small
                  type="grow"
                  variant="secondary"
                />
                <!-- We add an SR only text for screen readers -->
                <span class="sr-only">Please wait...</span>
              </div>
            </template>
            <b-input-group
              class="input-group-merge"
              :aria-hidden="isloader ? 'true' : null"
            >
              <b-form-input
                ref="searchmtrl"
                v-model="mtrl"
                :disabled="isloader"
                placeholder="Ingrese matricula para su busqueda"
                class="search-product"
                autofocus
                @keydown.native="GetInfo"
              />
              <b-input-group-append is-text>
                <feather-icon
                  icon="SearchIcon"
                  class="text-muted"
                />
              </b-input-group-append>
            </b-input-group>
          </b-overlay>
        </b-col>
      </b-row>
    </div>
    <!-- Alert: instrucciones -->
    <transition name="fade">
      <section v-if="userData === null">
        <b-alert
          variant="primary"
          class="m-2"
          show
        >
          <h4 class="alert-heading">
            Información
          </h4>
          <div class="alert-body">
            <feather-icon
              class="mr-25"
              icon="InfoIcon"
            />
            <span class="ml-25">Ingrese la matricula del estudiante y presione <b>ENTER</b>.</span>
          </div>
        </b-alert>
      </section>
    </transition>

    <transition name="fade">
      <section v-if="userData !== null">
        <!-- identificacion -->
        <b-row>
          <b-col
            cols="12"
            class="mb-2 text-center"
          >
            <label>Especialidades</label>
            <v-select
              style="text-overflow: ellipsis;"
              :value="planChoice"
              :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
              :options="planes"
              class="w-100"
              size="sm"
              label="nombre"
              :reduce="pln => pln.id"
              @input="aplyfilterplan"
            />
          </b-col>
          <b-col
            cols="12"
          >
            <user-general
              :credencial="userData.alumno"
              :profesion="userData.profesion"
            />
          </b-col>
        </b-row>
        <!-- Historial -->
        <b-row>
          <!-- BECAS/DOCS -->
          <b-col cols="12">
            <!-- Becas -->
            <b-card class="mb-2 business-card">
              <!-- Título de becas  -->
              <b-card-title class="mb-1">
                Becas activas
              </b-card-title>

              <!-- Mensaje de en caso de no tener los becas -->
              <b-alert
                v-if="userData.becas.length === 0"
                variant="warning"
              >
                <div class="alert-body text-center">
                  <small>No tiene becas actualmente.</small>
                </div>
              </b-alert>
              <becasx-alumno
                v-else
                :datos="userData.becas"
              />
            </b-card>
          </b-col>
          <!-- documentacion -->
          <b-col cols="12">
            <b-card class="mb-2 business-card">
              <!-- Título de archivos guardados -->
              <b-card-title class="mb-1">
                Documentación actual
              </b-card-title>

              <!-- Mensaje de en caso de no tener los documentos -->
              <b-alert
                variant="warning"
                :show="userData.documentacion.length === 0"
              >
                <div class="alert-body text-center">
                  <small>No tienes archivos por el momento.</small>
                </div>
              </b-alert>

              <document-list
                style="max-height: 250px;overflow-y: scroll;"
                :data="userData.documentacion"
                status-icon
              />
            </b-card>
          </b-col>
          <!-- estado de cuenta -->
          <b-col cols="12">
            <estado-cuenta
              v-if="userData !== null"
              :matricula="parseInt(mtrl, 10)"
              class="mb-2"
            />
          </b-col>
          <!-- Kardex -->
          <b-col cols="12">
            <b-card class="mb-2 business-card">
              <!-- Título de archivos guardados -->
              <b-card-title class="mb-1">
                Kardex actual
              </b-card-title>

              <!-- Mensaje de en caso de no tener los documentos -->
              <b-alert
                variant="warning"
                :show="userData.cursos.length === 0"
              >
                <div class="alert-body text-center">
                  <small>No tiene cursos actualmente.</small>
                </div>
              </b-alert>
              <cursosx-alumno :datos="userData.cursos" />
            </b-card>
          </b-col>
          <!-- SOLICITUDES -->
          <b-col cols="12">
            <b-card class="mb-2 business-card">
              <!-- Título de archivos guardados -->
              <b-card-title class="mb-1">
                Solicitudes
              </b-card-title>

              <!-- Mensaje de en caso de no tener los documentos -->
              <b-alert
                variant="warning"
                :show="userData.solicitudes.length === 0"
              >
                <div class="alert-body text-center">
                  <small>No tiene solicitudes actualmente.</small>
                </div>
              </b-alert>
              <requestx-alumno :datos="userData.solicitudes" />
            </b-card>
          </b-col>
          <!-- APORTACIONES -->
          <b-col cols="12">
            <b-card class="mb-2 business-card">
              <!-- Título de transacciones -->
              <b-card-title class="mb-1">
                Aportaciones
              </b-card-title>

              <!-- Mensaje de en caso de no tener los transacciones -->
              <b-alert
                variant="warning"
                :show="userData.transacciones.length === 0"
              >
                <div class="alert-body text-center">
                  <small>No tiene transacciones actualmente.</small>
                </div>
              </b-alert>
              <aportacionesx-alumno :datos="userData.transacciones" />
            </b-card>
          </b-col>
        </b-row>
      </section>
    </transition>

  </div>
</template>

<script>
import store from '@/store'
import {
  ref, onUnmounted, onMounted, getCurrentInstance,
} from '@vue/composition-api'
import {
  BRow,
  BCol,
  BAlert,
  BInputGroup,
  BFormInput,
  BInputGroupAppend,
  // BCardGroup,
  BCard,
  BCardTitle,
  BOverlay,
  BSpinner,
} from 'bootstrap-vue'
import vSelect from 'vue-select'
import 'vue-select/dist/vue-select.css'
import { useToast } from 'vue-toastification/composition'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import documentList from '@/views/components/documentacion/documentList.vue'
import EstadoCuenta from '@/views/campus/components/compras/compras-preview/components/estadoCuenta.vue'
import UserGeneral from './Sections/InfoGeneral.vue'
import CursosxAlumno from './Sections/CursosxAlumno.vue'
import RequestxAlumno from './Sections/RequestxAlumno.vue'
import BecasxAlumno from './Sections/BecasxAlumno.vue'
import AportacionesxAlumno from './Sections/AportacionesxAlumno.vue'
import { LoadResumen } from './useResumen'
import { listaPlanes } from '../../components/compras/useCompras'

export default {
  components: {
    BRow,
    BCol,
    BAlert,
    BInputGroup,
    BFormInput,
    BInputGroupAppend,
    vSelect,
    // BCardGroup,
    BCard,
    BCardTitle,
    BOverlay,
    BSpinner,
    // Local Components
    UserGeneral,
    CursosxAlumno,
    documentList,
    RequestxAlumno,
    BecasxAlumno,
    AportacionesxAlumno,
    EstadoCuenta,
  },
  setup() {
    const vm = getCurrentInstance().proxy
    const userData = ref(null)
    const isloader = ref(false)
    const toast = useToast()
    const mtrl = ref(null)
    const planChoice = ref(null)
    const planes = ref([])

    const USER_APP_STORE_MODULE_NAME = 'Historial-alumno'

    const loadPlanes = async () => {
      isloader.value = true
      await listaPlanes()
        .then(response => {
          planes.value = response.data
          isloader.value = false
        })
        .catch(error => {
          isloader.value = false
          toast({
            component: ToastificationContent,
            props: {
              title: 'Error en petición [Planes]',
              text: `${error} Intente de nuevo por favor.`,
              icon: 'AlertCircleIcon',
              variant: 'danger',
            },
          },
          { timeout: 10000 })
        })
    }

    // Register module
    // if (!store.hasModule(USER_APP_STORE_MODULE_NAME)) store.registerModule(USER_APP_STORE_MODULE_NAME, userStoreModule)

    // UnRegister on leave
    onUnmounted(() => {
      if (store.hasModule(USER_APP_STORE_MODULE_NAME)) store.unregisterModule(USER_APP_STORE_MODULE_NAME)
    })

    // request api
    const filtrarHistorico = async () => {
      try {
        // Validar que mtrl.value y planChoice.value sean numéricos
        const mtrlValue = Number(mtrl.value)
        const planChoiceValue = Number(planChoice.value)

        // eslint-disable-next-line no-restricted-globals
        if (isNaN(mtrlValue) || isNaN(planChoiceValue)) {
          throw new Error('Ambos valores deben ser numéricos.')
        }

        if (mtrlValue <= 0 || planChoiceValue <= 0) {
          throw new Error('Ambos valores deben ser positivos y válidos.')
        }

        // Inicia el loader
        isloader.value = true

        // Realizar la carga del resumen
        const response = await LoadResumen(mtrlValue, planChoiceValue)
        isloader.value = false
        vm.$refs.searchmtrl.focus()

        if (response.status === 200) {
          userData.value = response.datos
        } else {
          userData.value = null
          toast(
            {
              component: ToastificationContent,
              props: {
                title: 'Atención',
                text: response.message,
                icon: 'AlertCircleIcon',
                variant: 'warning',
              },
            }, { timeout: 9000, position: 'top-center' },
          )
        }
      } catch (error) {
        isloader.value = false
        toast(
          {
            component: ToastificationContent,
            props: {
              title: 'Atención',
              text: error.message || 'Ocurrió un error inesperado.',
              icon: 'AlertCircleIcon',
              variant: 'warning',
            },
          },
          { timeout: 9000 },
        )
      }
    }

    // CHANGE PLAN
    const aplyfilterplan = item => {
      // setear plan seleccionado
      planChoice.value = item
      // console.log(`plan choice = ${item}`)
      filtrarHistorico()
    }

    const GetInfo = event => {
      // console.log(`evento = ${event.which}`)
      if (event.which === 13) {
        filtrarHistorico()
      }
    }

    onMounted(
      () => {
        loadPlanes()
        planChoice.value = 1
        vm.$refs.searchmtrl.focus()
      },
    )

    return {
      userData,
      mtrl,
      planChoice,
      planes,
      isloader,
      GetInfo,
      aplyfilterplan,
      loadPlanes,
    }
  },
}
</script>

<style scoped>
  .fade-enter-active, .fade-leave-active {
  transition: opacity .5s;
  }
  .fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
    opacity: 0;
  }
</style>
